module.exports = __webpack_public_path__ + "img/nf.52897a6f.svg";